import { motion } from 'framer-motion';
import ContactForm from '../ContactForm';

interface ContactModalWrapperProps {
    onClose: () => void;
}

export default function ContactModalWrapper({ onClose }: ContactModalWrapperProps) {
    return (
        <div className="fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4 backdrop-blur-sm" onClick={onClose}>
            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                className="bg-white w-full max-w-md rounded-2xl overflow-hidden shadow-2xl relative"
                onClick={e => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 bg-slate-100 p-2 rounded-full hover:bg-slate-200 transition text-slate-500 hover:text-slate-800"
                >
                    ✕
                </button>
                <ContactForm onClose={onClose} />
            </motion.div>
        </div>
    );
}
